import { IPromise } from "angular";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { IHasResponseStatus } from "../../../../records/server/query";
import { $confirm } from "../../../../../@custom_types/confirm";

export class UserProfileApiKeyPageController {
  static $inject = [ServerUtilityName, "$confirm"];

  response: RegenerateKeyResponse | undefined;

  constructor(
    private readonly serverUtility: ServerUtility,
    private readonly $confirm: $confirm
  ) {}

  generateApiKeys() {
    this.$confirm({
      text: "Are you sure you want to invalidate any existing keys and generate new API keys?",
    }).then(() => {
      this.serverUtility
        .sendApiRequest<RegenerateKeyResponse>({
          url: "/api/user/regenerateApiKeys",
          method: "post",
        })
        .then((result) => {
          this.response = result;
        });
    });
  }
}

interface RegenerateKeyResponse extends IHasResponseStatus {
  Results: UserApiKey[];
}

interface UserApiKey {
  Key: string;
  KeyType: string;
  ExpiryDate: string;
}
